//
// Copyright (c) 2025 Comcast
//

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import IconLink from 'components/Shared/IconLink/Index'

const MoveLink = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <IconLink
      onClick={onClick}
      iconName='icon-arrow-right1-24'
      text={t('ticketPage.moveTicketLink')}
    />
  )
}

MoveLink.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export default MoveLink
